import { action } from 'mobx';
import { QuestionModel } from '@/survey/logic/QuestionModel';
import type { Answer } from '../../../types';

export class SingleSelectModel extends QuestionModel {
  @action
  handleClickOption = (answerId: number) => {
    if (this.selectedAnswers.at(0)?.id === answerId) {
      this.set_selectedAnswers([]);
    } else {
      const answerToSelect = this.question.form_answers.find((a) => a.id === answerId);
      if (!answerToSelect) {
        return;
      }

      this.set_selectedAnswers([answerToSelect]);
    }
  };

  isAnswerSelected(answer: Answer): boolean {
    return this.selectedAnswers.some((a) => a === answer);
  }
}
